import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-menus',
  templateUrl: './main-menus.component.html',
  styleUrls: ['./main-menus.component.scss']
})
export class MainMenusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
